import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import StatusBadge from '../common/StatusBadge';
import { formatCurrency, formatDate } from '../../utils/formatters';
import '../../pages/ApplicantPages.css';
import './PropertyPages.css';

const PropertyList = ({ properties }) => {
  const [search, setSearch] = useState('');
  const term = search.trim().toLowerCase();
  const shown = properties.filter((p) => !term || (p.address || '').toLowerCase().includes(term));

  if (properties.length === 0) {
    return (
      <div className="ap-card prop-empty">
        <h2>Add your first property</h2>
        <p>
          Add a property, and you get a link and QR code to share. Applicants use it to apply, and you compare them
          when they do.
        </p>
        <Link to="/properties/new" className="btn-primary ap-button">Add a property</Link>
      </div>
    );
  }

  return (
    <>
      {properties.length > 5 && (
        <input
          type="search"
          className="prop-search"
          placeholder="Search by address"
          aria-label="Search properties by address"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      )}
      <ul className="ap-list">
        {shown.map((p) => (
          <li key={p.id} className="ap-card ap-list__item">
            <div>
              <h2 className="ap-list__title"><Link to={`/properties/${p.id}`}>{p.address}</Link></h2>
              <p className="ap-muted">
                {formatCurrency(p.monthly_rent_amount)} a month · available {formatDate(p.occupation_date)} ·{' '}
                {p.applications_count || 0} {p.applications_count === 1 ? 'application' : 'applications'}
              </p>
            </div>
            <div className="ap-list__actions">
              {p.status === 'active' && p.apply_link_enabled && <span className="ap-pill ap-pill--granted">Link on</span>}
              <StatusBadge status={p.status} text={p.status === 'active' ? 'Active' : 'Inactive'} />
              <Link to={`/properties/${p.id}`} className="ap-button ap-button--ghost">Open</Link>
            </div>
          </li>
        ))}
      </ul>
      {shown.length === 0 && <p className="ap-muted">No property matches that search.</p>}
    </>
  );
};

PropertyList.propTypes = {
  properties: PropTypes.array.isRequired
};

export default PropertyList;
